/** Shortcut-Übersicht als Modal (Taste „?“ oder ?-Button). */
export class ShortcutOverlay {
  el: HTMLElement;
  private visible = false;

  get isVisible(): boolean {
    return this.visible;
  }

  constructor(root: HTMLElement) {
    this.el = document.createElement('div');
    this.el.className = 'overlay hidden';
    const box = document.createElement('div');
    box.className = 'overlay-box';
    box.innerHTML = `
      <h2>Tastenkürzel — wie in SketchUp</h2>
      <div class="shortcut-cols">
        <table>
          <tr><th>Werkzeug</th><th></th></tr>
          <tr><td>Auswahl</td><td><kbd>Leertaste</kbd></td></tr>
          <tr><td>Linie</td><td><kbd>L</kbd></td></tr>
          <tr><td>Rechteck</td><td><kbd>R</kbd></td></tr>
          <tr><td>Kreis</td><td><kbd>C</kbd></td></tr>
          <tr><td>Bogen</td><td><kbd>A</kbd></td></tr>
          <tr><td>Versatz</td><td><kbd>F</kbd></td></tr>
          <tr><td>Push/Pull</td><td><kbd>P</kbd></td></tr>
          <tr><td>Verschieben</td><td><kbd>M</kbd></td></tr>
          <tr><td>Drehen</td><td><kbd>Q</kbd></td></tr>
          <tr><td>Skalieren</td><td><kbd>S</kbd></td></tr>
          <tr><td>Radiergummi</td><td><kbd>E</kbd></td></tr>
          <tr><td>Maßband</td><td><kbd>T</kbd></td></tr>
          <tr><td>Farbe</td><td><kbd>B</kbd></td></tr>
          <tr><td>Umlauf</td><td><kbd>O</kbd></td></tr>
          <tr><td>Schwenken</td><td><kbd>H</kbd></td></tr>
          <tr><td>Zoom</td><td><kbd>Z</kbd></td></tr>
        </table>
        <table>
          <tr><th>Befehl</th><th></th></tr>
          <tr><td>Rückgängig / Wiederholen</td><td><kbd>Strg+Z</kbd> / <kbd>Strg+Umschalt+Z</kbd></td></tr>
          <tr><td>Gruppieren / Lösen</td><td><kbd>Strg+G</kbd> / <kbd>Strg+Umschalt+G</kbd></td></tr>
          <tr><td>Speichern / Öffnen</td><td><kbd>Strg+S</kbd> / <kbd>Strg+O</kbd></td></tr>
          <tr><td>Auf alles zoomen</td><td><kbd>Strg+Umschalt+E</kbd></td></tr>
          <tr><td>Löschen</td><td><kbd>Entf</kbd></td></tr>
          <tr><td>Abbrechen / Kette beenden</td><td><kbd>Esc</kbd></td></tr>
          <tr><td>Achse sperren (rot/grün/blau)</td><td><kbd>→</kbd> <kbd>←</kbd> <kbd>↑</kbd></td></tr>
          <tr><td>Standardansichten</td><td><kbd>1</kbd>–<kbd>7</kbd></td></tr>
          <tr><td>Exakte Maße</td><td>Zahl tippen, z. B. <kbd>120</kbd> oder <kbd>1,5m</kbd>, Listen mit <kbd>;</kbd> (<kbd>120;60</kbd>), dann <kbd>Enter</kbd></td></tr>
          <tr><td>Kamera</td><td>Mausrad = Zoom zum Cursor · Mittelklick ziehen = Umlauf um Cursorpunkt · +<kbd>Umschalt</kbd> = Schwenken · Doppelklick Mausrad = zentrieren</td></tr>
          <tr><td>Richtung sperren</td><td><kbd>Umschalt</kbd> halten: Linie bleibt auf der eingerasteten Achse · Rechteck/Kreis auf der aktuellen Ebene · Verschieben/Ziehen entlang der Hauptrichtung</td></tr>
          <tr><td>Senkrecht zeichnen</td><td>Linie: Maus entlang der blauen Achse (<kbd>↑</kbd> sperrt) · Rechteck/Kreis: Maus nach oben ziehen oder <kbd>→</kbd>/<kbd>←</kbd> sperrt die senkrechte Ebene, <kbd>↑</kbd> waagrecht, <kbd>↓</kbd> frei</td></tr>
          <tr><td>Spiegeln</td><td><kbd>Umschalt</kbd>+<kbd>H</kbd> horizontal (rot) · <kbd>Umschalt</kbd>+<kbd>J</kbd> horizontal (grün) · <kbd>Umschalt</kbd>+<kbd>V</kbd> vertikal (blau)</td></tr>
          <tr><td>Gruppen</td><td>Klick = ganze Gruppe · Doppelklick = öffnen · Esc/Klick daneben = schließen</td></tr>
          <tr><td>Möbel stellen</td><td>Im Panel „Möbel stellen“ auswählen → in die Szene klicken · <kbd>→</kbd>/<kbd>←</kbd> = um 90° drehen · <kbd>Esc</kbd> = fertig</td></tr>
          <tr><td>Eigenes Möbel speichern</td><td>Gruppe zeichnen (<kbd>Strg</kbd>+<kbd>G</kbd>) und anklicken → im Panel benennen und „Auswahl speichern“</td></tr>
          <tr><td>Ebenen</td><td>Panel „Ebenen“: Auge = ein-/ausblenden · Name klicken = wählen · „Alle einblenden“ · Rechtsklick → Ausblenden · Deckkraft im Auswahl-Panel des aktiven Objekts</td></tr>
        </table>
      </div>
      <p class="panel-note">Kopieren beim Ziehen: <kbd>⌘</kbd>/<kbd>Strg</kbd> gedrückt halten — im Auswahl- und im Verschieben-/Drehwerkzeug.</p>`;
    const close = document.createElement('button');
    close.className = 'top-btn overlay-close';
    close.textContent = 'Schließen';
    close.onclick = () => this.hide();
    box.appendChild(close);
    this.el.appendChild(box);
    this.el.addEventListener('click', (e) => {
      if (e.target === this.el) this.hide();
    });
    root.appendChild(this.el);
  }

  toggle(): void {
    this.visible ? this.hide() : this.show();
  }

  show(): void {
    this.visible = true;
    this.el.classList.remove('hidden');
  }

  hide(): void {
    this.visible = false;
    this.el.classList.add('hidden');
  }
}
